/**
 * Shared schema.org fragments for Product offers (Google Merchant listings).
 * Google requires `shippingDetails` and `hasMerchantReturnPolicy` inside `offers`.
 */

export const PRODUCT_DESCRIPTION_FALLBACK =
  "Nov izdelek preverjenega ponudnika v spletnem nakupovalnem središču kupish.si — preverite opis, ceno in pogoje dostave.";

export function buildShippingDetails(shippingFee: number | null | undefined, freeOver?: number | null) {
  const rate = typeof shippingFee === "number" && !isNaN(shippingFee) ? shippingFee : 0;
  return {
    "@type": "OfferShippingDetails",
    shippingRate: {
      "@type": "MonetaryAmount",
      value: rate.toFixed(2),
      currency: "EUR",
      ...(typeof freeOver === "number" && !isNaN(freeOver)
        ? { description: `Brezplačna dostava nad ${freeOver.toFixed(2)} EUR` }
        : {}),
    },
    shippingDestination: {
      "@type": "DefinedRegion",
      addressCountry: "SI",
    },
    deliveryTime: {
      "@type": "ShippingDeliveryTime",
      handlingTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 5, unitCode: "DAY" },
      transitTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 3, unitCode: "DAY" },
    },
  };
}

/** Slovenian consumer law: 14 days for non-personalised goods. */
export const MERCHANT_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy",
  applicableCountry: "SI",
  returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
  merchantReturnDays: 14,
  returnMethod: "https://schema.org/ReturnByMail",
  returnFees: "https://schema.org/ReturnShippingFees",
  returnShippingFeesAmount: {
    "@type": "MonetaryAmount",
    value: "0.00",
    currency: "EUR",
  },
} as const;
